<svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0 6.76253L3.26667 10.0283L3.90414 9.39174L1.72575 7.21245H10.7981V6.31171H1.72575L3.90413 4.13333L3.26666 3.49586L0 6.76253ZM11.7003 1.08829L14.2186 3.60659H11.7003V1.08829ZM14.9111 3.02322L12.2828 0.39583C12.0312 0.144259 11.6823 0 11.327 0H5.38879V5.40988H6.29043V0.901646H10.7987V4.50824H14.4053V11.7214H6.29043V8.11482H5.38877V12.623H15.3069V3.97987C15.3069 3.62462 15.1626 3.27568 14.9111 3.02322Z"
    fill="currentColor" />
</svg>
